import { render, staticRenderFns } from "./editNosis.vue?vue&type=template&id=200a87a8&scoped=true&"
import script from "./editNosis.vue?vue&type=script&lang=js&"
export * from "./editNosis.vue?vue&type=script&lang=js&"
import style0 from "./editNosis.vue?vue&type=style&index=0&id=200a87a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200a87a8",
  null
  
)

export default component.exports